import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

import styled, { withTheme } from "styled-components";
import { CaptionSemiboldStyle } from "../../Typography";
import DropDownContent from "./DropdownContent";
import LinkArrow from "../shared/LinkArrow";

import theme from "../../../styles/theme";

const StyledButton = styled.button`
  ${CaptionSemiboldStyle};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${props =>
    props.open ? theme.colors.green3 : theme.colors.green5};
  transition: color 250ms ease-in-out 0s;
  text-decoration: none;
  margin-right: 20px;
  &:hover {
    color: ${() => theme.colors.green3};
  }
`;

const ArrowWrapper = styled.span`
  margin-left: 4px;
  margin-top: 2px;
  position: relative;
  display: inline-block;
  transition: transform .5s;
  transform-origin: 25% center;
  transform-origin: center 25%;
  transform: rotate(${(props) => {
    return props.open ? "180deg" : "0deg"
  }});
`;

const RelativeWrapper = styled.div`
  position: relative;
  z-index: 1;
  padding: 8px 24px 16px;
`;

const DropdownContentWrapper = styled.div`
  position: absolute;
  width: 100%;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  top: 100%;
  left: 0;
  z-index: -1;
  color: ${() => theme.colors.green5};
`;

const DropdownBackground = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: calc(100% + 82px);
  top: -82px;
  left: 0;
  background: ${() => theme.colors.green1};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  z-index: -1;
  transform-origin: top center;
`;

const DropdownLink = ({
  children,
  className,
  dropDownContent,
  isOpen = false
}) => {
  const [open, setOpen] = useState(isOpen);
  return (
    <span
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <StyledButton data-label={children} className={className} open={open}>
        {children}
        <ArrowWrapper open={open} className="arrow-wrapper">
          <LinkArrow
            fillColor={open ? theme.colors.green3 : theme.colors.green5}
          />
        </ArrowWrapper>
      </StyledButton>
      <AnimatePresence initial mode="wait">
        {open && (
          <DropdownContentWrapper>
            <RelativeWrapper>
              <DropDownContent content={dropDownContent} />
              <DropdownBackground
                initial={{
                  scaleY: 0,
                  boxShadow: "0px 10px 0px rgba(89, 89, 89, 0)"
                }}
                animate={{
                  scaleY: 1,
                  boxShadow: "0px 10px 50px rgba(89, 89, 89, 0.2)"
                }}
                exit={{
                  scaleY: 0,
                  boxShadow: "0px 10px 0px rgba(89, 89, 89, 0)",
                  transition: {
                    duration: 0.5,
                    delay: 0,
                    ease: [1, 0.1, 0.1, 1],
                    boxShadow: {
                      duration: 0.5,
                      delay: 0
                    }
                  }
                }}
                transition={{
                  duration: 0.5,
                  ease: [1, 0.1, 0.1, 1],
                  boxShadow: {
                    duration: 0.9,
                    delay: 0.1
                  }
                }}
              />
            </RelativeWrapper>
          </DropdownContentWrapper>
        )}
      </AnimatePresence>
    </span>
  );
};

export default withTheme(DropdownLink);
